const URLS = {
    LOGIN: 'auth/login',
    USER: 'auth/user',
    VERIFY_SITE_MAP: 'site/getByMapId',
    CREATE_SITE: 'site/create-site',
    UPLOAD_SITE_IMAGE: 'image/site',
    UPDATE_SITE: 'site',
    GET_BUILDING: 'building',
    CREATE_BUILDING: 'building/create',
    CREATE_FLOOR: 'floor/create',
    UPLOAD_FLOOR_IMAGE: 'image/floor',
    GET_FLOORS: 'floor',
    SWAP_FLOOR: 'floor/swap-elevation',
    CHANGE_BUILDING_NAME: 'building',
    DELETE_BUILDING: 'building',
    UPDATE_FLOOR: 'floor',
    DELETE_FLOOR: 'floor',
    UPDATE_FLOOR_GEOREFERENCE: 'floor',
    STATE: 'state',
    ZONE: 'zones',
    LOCATION: 'location',
    CATEGORY: 'category',
    LAYER: 'layer',
    IMAGE: 'image',
    PUBLISH: 'site',
    SHAPE: 'shape',
    CONNECTION: 'connection',
    ICONS: 'category/get-icons',
    EVENT: 'event',
    MAP_OBJECT: 'image/location/map-object',
    MAP_OBJECT_3D: 'map-object',
    MAP_OBJECT_3D_PROPERTY: 'map-object-property',
    SUPPORTED_LANGUAGES: 'multilingual/supported-languages',
    SITE_LANGUAGES: 'multilingual',
    DOWNLOAD_LANGUAGE_EXCEL: 'multilingual',
    UPLOAD_LANGUAGE_EXCEL: 'image/multilingual',
    API_KEY: 'api-key',
    NODE: 'node',
    GET_USER_ORGANISATIONS: 'auth/get-user-organisations',
    USER_LOGIN: 'auth/user-login',
    SITE_LIST: 'site',
    FEEDBACK: 'feedback',
    VISITOR: 'visitor'
};
export default URLS;
